import { DeprecatedSelect } from "@octopusdeploy/design-system-octopus-components";
import type { CloudRegionEndpointResource, WorkerPoolResource } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues } from "@octopusdeploy/octopus-server-client";
import { EndpointRegistrationKeyValues } from "@octopusdeploy/portal-routes";
import type React from "react";
import { AzureCloudRegion } from "~/components/Images/MachineSettings/AzureCloudRegion";
import { ExpandableFormSection, Summary } from "~/components/form";
import CommonSummaryHelper from "~/utils/CommonSummaryHelper";
import cloudRegionCategory from "./CloudRegionCategoryDefinition";
import EndpointCard from "./EndpointCard";
import type { CategorizedEndpointRegistration } from "./endpointRegistry";
import styles from "./styles.module.less";
interface CloudRegionEndpointProps {
    endpoint: CloudRegionEndpointResource;
    workerPools: WorkerPoolResource[];
    onChange(newValue: CloudRegionEndpointResource): void;
}
export const CloudRegionEndpoint: React.FC<CloudRegionEndpointProps> = ({ endpoint, workerPools, onChange }) => {
    return (<div>
            {workerPools.length > 1 && (<ExpandableFormSection errorKey={"DefaultWorkerPool"} title="Worker Pool" summary={endpoint.DefaultWorkerPoolId ? CommonSummaryHelper.resourceSummary(endpoint.DefaultWorkerPoolId, workerPools, "worker pool") : Summary.placeholder("No pool selected - default pool")} help="Select a default pool for this target (optional).">
                    <DeprecatedSelect label={"Select a default pool"} items={workerPools.map((e) => ({ value: e.Id, text: e.Name }))} value={endpoint.DefaultWorkerPoolId} allowFilter={true} allowClear={true} onChange={(x) => onChange({ ...endpoint, DefaultWorkerPoolId: x })} sortItems={false}/>
                </ExpandableFormSection>)}
        </div>);
};
CloudRegionEndpoint.displayName = "CloudRegionEndpoint"
const cloudRegionEndpointRegistration: CategorizedEndpointRegistration = {
    key: EndpointRegistrationKeyValues.CloudRegion,
    displayOrder: 100,
    communicationStyle: CommunicationStyleValues.None,
    name: "Cloud Region",
    categories: [cloudRegionCategory],
    renderCard: ({ registration, onNavigate, onClick }) => (<EndpointCard logo={<AzureCloudRegion className={styles.centreThumbnail} title={registration.name}/>} registrationName={registration.name} description="Execute steps multiple times with variables scoped for each iteration." onNavigate={onNavigate} onClick={onClick} communicationStyle={registration.communicationStyle}/>),
};
export { cloudRegionEndpointRegistration };
